var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24.0 24.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1366,0 L1366,768 L0,768 L0,0 L1366,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.463,0 C16.233,0 20.926,4.693 20.926,10.463 C20.926,16.232 16.233,20.926 10.463,20.926 C4.694,20.926 0,16.232 0,10.463 C0,4.693 4.694,0 10.463,0 Z M10.463,1.5 C5.521,1.5 1.5,5.521 1.5,10.463 C1.5,15.405 5.521,19.426 10.463,19.426 C15.405,19.426 19.426,15.405 19.426,10.463 C19.426,5.521 15.405,1.5 10.463,1.5 Z M10.3429,13.2042 C10.9889,13.2042 11.5149,13.7292 11.5149,14.3762 C11.5149,15.0222 10.9889,15.5482 10.3429,15.5482 C9.6969,15.5482 9.1709,15.0222 9.1709,14.3762 C9.1709,13.7292 9.6969,13.2042 10.3429,13.2042 Z M10.3794,5.55 C11.7164,5.55 12.8044,6.219 13.2194,7.294 C13.6574,8.427 13.1974,9.623 12.0174,10.411 C11.8294,10.533 11.7254,10.615 11.6154,10.729 C11.56515,10.78225 11.536275,10.877125 11.5237125,10.9469688 L11.5164,11.006 L11.4934,11.371 C11.5044,11.606 11.4014,11.855 11.2034,12.046 C11.0392333,12.206 10.8250667,12.3104444 10.5904139,12.3454444 L10.4474,12.358 L10.4084,12.358 C9.86332857,12.358 9.41310408,12.0001684 9.33555415,11.5247019 L9.3244,11.413 L9.3184,10.709 C9.3384,10.061 9.6094,9.767 9.9084,9.498 L10.1208954,9.31990741 L10.6724,8.875 C11.2106,8.524 11.2320356,8.18802222 11.1910788,8.01027852 L11.1694,7.94 C11.0644,7.666 10.7704,7.51 10.3644,7.51 C9.7244,7.5364 9.49912,7.89944 9.41976,8.131152 L9.39099556,8.23389748 C9.38781333,8.24847556 9.38533333,8.2616 9.3834,8.273 C9.2994,8.755 8.8434,9.105 8.2994,9.105 C7.5684,9.021 7.1554,8.529 7.2334,8.002 C7.34702963,7.22392593 8.06618464,5.75779698 9.97128467,5.57078931 L10.1964,5.555 L10.3794,5.55 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1218.0 -88.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(346.0 72.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(872.0000000000002 16.0000000000003)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.537000000000262 1.537000000000262)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 20.926,0 20.926,20.926 0,20.926 0,0",
    stroke: "none",
    fill: "#3949BB"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.309060d9195cb19790a7f6d33dd1deb0.svg";
export { ForwardRef as ReactComponent };